<template>
  <el-time-select
      ref="gjInput"
      v-bind="$attrs"
      v-on="$listeners"
      :size="mapSize"
      :style="{width}"
      :placeholder="placeholder">
  </el-time-select>
</template>

<script>
  import {sizeMap} from "../common";

  export default {
    name: "gj-time-select",
    props: {
      width: {
        type: String,
        default: '110px',
      },
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['default', 'mini', 'medium'].indexOf(value) !== -1
        }
      },
      placeholder: {
        type: String,
        default: '选择时间',
      },
    },
    computed: {
      mapSize() {
        return sizeMap[this.size];
      }
    },
  }
</script>

<style scoped>

</style>
